import { render } from "./v-booking.vue?vue&type=template&id=f1baf708&scoped=true"
import script from "./v-booking.vue?vue&type=script&lang=js"
export * from "./v-booking.vue?vue&type=script&lang=js"

import "./v-booking.vue?vue&type=style&index=0&id=f1baf708&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f1baf708"

export default script